import React from "react";
import "./footersolutioncard.css";

function FooterSolutionCard() {
  return (
    <div className="footer-solution-card-container">
      <img
        src="/images/footer-solution-card.svg"
        alt=""
        loading="lazy"
        decoding="async"
      />
      <div className="footer-solution-card-container-text">
        Leading provider of solutions for KYC of individuals & Merchant with
        fraud prevention signals.
      </div>
    </div>
  );
}

export default React.memo(FooterSolutionCard);
